import { ApartmentRounded, CheckCircleRounded } from "@mui/icons-material";
import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";

import { colors } from "./ui/colors";

interface InvitationAcceptedDialogProps {
  open: boolean;
  companyName: string;
  onClose: () => void;
}

export const InvitationAcceptedDialog = ({ open, companyName, onClose }: InvitationAcceptedDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "24px",
          overflow: "hidden",
          boxShadow: "0px 24px 70px rgba(15, 23, 42, 0.22)",
        },
      }}
      BackdropProps={{
        sx: {
          bgcolor: "rgba(15, 23, 42, 0.42)",
          backdropFilter: "blur(6px)",
        },
      }}
    >
      <DialogContent
        sx={{
          p: { xs: 3, sm: 4 },
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: 76,
            height: 76,
            mx: "auto",
            mb: 2.5,
            borderRadius: "24px",
            display: "grid",
            placeItems: "center",
            bgcolor: "rgba(34, 197, 94, 0.10)",
            color: "#16A34A",
          }}
        >
          <CheckCircleRounded sx={{ fontSize: 48 }} />
        </Box>

        <Typography
          sx={{
            fontSize: 26,
            fontWeight: 950,
            color: colors.gray.base,
            letterSpacing: "-0.03em",
            mb: 1,
          }}
        >
          Congratulations!
        </Typography>

        <Typography
          sx={{
            fontSize: 15,
            lineHeight: 1.6,
            fontWeight: 600,
            color: colors.gray[500],
            mb: 3,
          }}
        >
          You are now part of{" "}
          <Box
            component="span"
            sx={{
              fontWeight: 900,
              color: colors.gray.base,
            }}
          >
            {companyName}
          </Box>
          .
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            p: 1.75,
            mb: 3,
            borderRadius: "16px",
            textAlign: "left",
            bgcolor: "rgba(242, 140, 40, 0.08)",
            border: "1px solid rgba(242, 140, 40, 0.20)",
          }}
        >
          <Box
            sx={{
              width: 42,
              height: 42,
              minWidth: 42,
              borderRadius: "13px",
              display: "grid",
              placeItems: "center",
              bgcolor: "rgba(242, 140, 40, 0.14)",
              color: colors.orange.base,
            }}
          >
            <ApartmentRounded />
          </Box>

          <Box>
            <Typography
              sx={{
                fontSize: 11,
                fontWeight: 900,
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                color: colors.gray[500],
              }}
            >
              Your new company
            </Typography>

            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 900,
                color: colors.gray.base,
              }}
            >
              {companyName}
            </Typography>
          </Box>
        </Box>

        <Button
          variant="contained"
          fullWidth
          onClick={onClose}
          sx={{
            height: 48,
            borderRadius: "13px",
            bgcolor: colors.orange.base,
            textTransform: "none",
            fontWeight: 950,
            boxShadow: "0px 10px 22px rgba(242, 140, 40, 0.24)",
            "&:hover": {
              bgcolor: colors.orange[700],
            },
          }}
        >
          Continue
        </Button>
      </DialogContent>
    </Dialog>
  );
};
